import { isTravelataOperatorId } from '@entities/operator';
import { type IHotelOfferTariff } from '@ve/components/hotel/hotelOffersTariffsPopup/common/types';
import { type IReturnProductHotelOffer } from '@ve/pages/hotel/types';

const resolveOperatorId = (operator: unknown): number | null => {
  if (operator === null || operator === undefined) return null;
  const rawId = typeof operator === 'object' ? (operator as { id?: number | string }).id : operator;
  return rawId === null || rawId === undefined ? null : Number(rawId);
};

export default (hotelOffers: IReturnProductHotelOffer[]): IHotelOfferTariff[] =>
  hotelOffers
    .filter((hotelOffer) => {
      const operatorId = resolveOperatorId(hotelOffer.operator);
      return operatorId === null || isTravelataOperatorId(operatorId);
    })
    .map((hotelOffer) => ({
      tourId: hotelOffer.id,
      price: hotelOffer.price,
      roomName: hotelOffer.room.name,
      cancellationPolicy: hotelOffer.cancellationPolicy,
    }));
